import React from 'react';
import Hint, { HintTitle, HintText } from '../../basics/hint';

interface VideoRequirementsHintProps {
  className?: string;
}

export const VideoRequirementsHint: React.FC<VideoRequirementsHintProps> = ({
  className,
}) => (
  <Hint className={className} noTitle align="left">
    <HintTitle>Video requirements:</HintTitle>
    <HintText>
      Min. Dimensions: <b>1920x1080</b>
    </HintText>
    <HintText>
      Aspect Ratio: <b>16:9</b>
    </HintText>
    <HintText>
      Formats: <b>MPEG-TS, MPEG-4</b>
    </HintText>
    <HintText>
      Codecs: <b>video/H264, video/H265</b>
    </HintText>
    <HintText>
      Frame Rates: <b>23.976, 29.970</b>
    </HintText>
    <HintText>
      Min. Bit Rate: <b>15Mbits/s</b>
    </HintText>
  </Hint>
);
